/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Editor_Add_Event_GroupInputs */

const en_editor_add_event_group = /** @type {(inputs: Editor_Add_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add new event group`)
};

const fr_editor_add_event_group = /** @type {(inputs: Editor_Add_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un nouveau groupe d'evenements`)
};

const de_editor_add_event_group = /** @type {(inputs: Editor_Add_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Neue Ereignisgruppe hinzufügen`)
};

const it_editor_add_event_group = /** @type {(inputs: Editor_Add_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi nuovo gruppo di eventi`)
};

const ru_editor_add_event_group = /** @type {(inputs: Editor_Add_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Добавить новую группу событий`)
};

const es_editor_add_event_group = /** @type {(inputs: Editor_Add_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar nuevo grupo de eventos`)
};

const zh_cn2_editor_add_event_group = /** @type {(inputs: Editor_Add_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`添加新事件组`)
};

const ja_editor_add_event_group = /** @type {(inputs: Editor_Add_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`新しいイベントグループを追加`)
};

const hi_editor_add_event_group = /** @type {(inputs: Editor_Add_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`नया इवेंट समूह जोड़ें`)
};

const pt_pt2_editor_add_event_group = /** @type {(inputs: Editor_Add_Event_GroupInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar novo grupo de eventos`)
};

/**
* | output |
* | --- |
* | "Add new event group" |
*
* @param {Editor_Add_Event_GroupInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const editor_add_event_group = /** @type {((inputs?: Editor_Add_Event_GroupInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Editor_Add_Event_GroupInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_editor_add_event_group(inputs)
	if (locale === "de") return de_editor_add_event_group(inputs)
	if (locale === "it") return it_editor_add_event_group(inputs)
	if (locale === "ru") return ru_editor_add_event_group(inputs)
	if (locale === "es") return es_editor_add_event_group(inputs)
	if (locale === "zh-CN") return zh_cn2_editor_add_event_group(inputs)
	if (locale === "ja") return ja_editor_add_event_group(inputs)
	if (locale === "hi") return hi_editor_add_event_group(inputs)
	if (locale === "pt-PT") return pt_pt2_editor_add_event_group(inputs)
	return en_editor_add_event_group(inputs)
});